export default {"src":"/_next/static/media/mobile.755531c2.svg","height":61,"width":34};